(function( $, doc ) {
    "use strict";

    (function(){

        // BUILDER form
        /*$( function() {

            $(".forminator-builder").sortable({
                revert: true,
                cursor: "move"
            });

            $("#draggable-name").draggable({
                appendTo: "body",
                helper: "clone",
                revert: "invalid",
                connectToSortable: ".forminator-builder"
            });

            $(".forminator-builder, .forminator-row").disableSelection();

        } );*/

        // BUILDER fields
        /*$( function() {

            $(".forminator-manage-field-options").sortable({
                revert: true,
                cursor: "move"
            });

        } );*/

        // SIDEBAR general, options
        $(document).on("click", "#forminator-add-new-option", function(e){
            
            e.preventDefault();

            var $this = $(this),
                $options = $this.prev(".forminator-manage-field-options");

            var $new_option = '<div class="forminator-field-option-edit">' +

                '<div class="wpmudev-drag">' +
                    
                    '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="59" viewBox="0 0 50 59" preserveAspectRatio="none" class="wpmudev-icon wpmudev-i_drag"><path fill-rule="evenodd" d="M4.167 8.333C1.865 8.333 0 6.468 0 4.167 0 1.865 1.865 0 4.167 0c2.3 0 4.166 1.865 4.166 4.167 0 2.3-1.865 4.166-4.166 4.166zm0 25C1.865 33.333 0 31.468 0 29.167 0 26.865 1.865 25 4.167 25c2.3 0 4.166 1.865 4.166 4.167 0 2.3-1.865 4.166-4.166 4.166zm41.666-25c-2.3 0-4.166-1.865-4.166-4.166C41.667 1.865 43.532 0 45.833 0 48.135 0 50 1.865 50 4.167c0 2.3-1.865 4.166-4.167 4.166zm0 25c-2.3 0-4.166-1.865-4.166-4.166 0-2.302 1.865-4.167 4.166-4.167C48.135 25 50 26.865 50 29.167c0 2.3-1.865 4.166-4.167 4.166zM25 8.333c-2.3 0-4.167-1.865-4.167-4.166C20.833 1.865 22.7 0 25 0c2.3 0 4.167 1.865 4.167 4.167 0 2.3-1.866 4.166-4.167 4.166zm0 25c-2.3 0-4.167-1.865-4.167-4.166C20.833 26.865 22.7 25 25 25c2.3 0 4.167 1.865 4.167 4.167 0 2.3-1.866 4.166-4.167 4.166zm-20.833 25C1.865 58.333 0 56.468 0 54.167 0 51.865 1.865 50 4.167 50c2.3 0 4.166 1.865 4.166 4.167 0 2.3-1.865 4.166-4.166 4.166zm41.666 0c-2.3 0-4.166-1.865-4.166-4.166 0-2.302 1.865-4.167 4.166-4.167C48.135 50 50 51.865 50 54.167c0 2.3-1.865 4.166-4.167 4.166zm-20.833 0c-2.3 0-4.167-1.865-4.167-4.166C20.833 51.865 22.7 50 25 50c2.3 0 4.167 1.865 4.167 4.167 0 2.3-1.866 4.166-4.167 4.166z"/></svg>' +
                    
                '</div>' +

                '<div class="wpmudev-input_radio">' +

                    '<input type="radio" id="">' +

                    '<label for=""></label>' +

                '</div>' +

                '<input type="text" class="wpmudev-input_text">' +

            '</div>';

            $options.append($new_option);

        });

        // CUSTOM FORM
        // Add a message on form template
        // when nothing has been added yet.
        $(document).ready(function(){

            var $container = $(".forminator-builder"),
                $buttons_container = $container.next(".forminator-buttons"),
                $buttons = $buttons_container.find(".wpmudev-button");

            var $empty_html = "<div class='forminator-row'>" +

                "<div class='forminator-col'>" +

                    "<p class='forminator-empty-message'>No fields yet, drag & drop them from the sidebar on the right.</p>" +

                "</div>" +

            "</div>";

            if ( $container.length === "" ) {
                $container.addClass("forminator-builder-is_empty");
                $container.append($empty_html);
                $buttons.attr("disabled", true);
            } else {
                $container.removeClass("forminator-builder-is_empty");
                $buttons.attr("disabled", false);
            }

        });

        // DRAG AND DROP
        // Get an element from sidebar and
        // drop it on the form builder.
        $( function() {

            var $fields = $(".forminator-fields"),
                $form = $(".form-builder");

            $("li", $fields).draggable({
                appendTo: "body",
                helper: "clone",
                revert: "invalid",
                containment: "document",
                cursor: "move"
            });

            $form.droppable({
                accept: ".forminator-fields li",
                classes: {
                    "ui-droppable-active": "ui-state-highlight"
                },
                drop: function( event, ui ) {
                    deleteImage( ui.draggable );
                }
            });

        } );

        // DRAG AND DROP
        // Get an element from the builder
        // and re-order.


    }());

}( jQuery, document ));